/** Notification ding — plays a short mp3 clip. Works on all browsers including mobile Safari. */

// Preload the audio file on import
const DING_URL = "/ding.mp3";
let _preloaded = false;

function preload() {
  if (_preloaded) return;
  _preloaded = true;
  // Fetch into browser cache so playback is instant
  fetch(DING_URL).catch(() => {});
}

// Preload on first user interaction (required for mobile)
if (typeof document !== "undefined") {
  const touch = () => {
    preload();
    document.removeEventListener("click", touch);
    document.removeEventListener("touchstart", touch);
  };
  document.addEventListener("click", touch, { once: true });
  document.addEventListener("touchstart", touch, { once: true });
  // Also preload immediately in case we're on desktop
  preload();
}

export function playDing() {
  // Create a new Audio each time — avoids issues with reuse, loading state, and concurrent plays
  const audio = new Audio(DING_URL);
  audio.volume = 1.0;
  audio.play().catch((err) => {
    console.warn("[ding] play blocked:", err.message);
  });
}
